export default __webpack_public_path__ + "static/media/CMS_Roles.c4eee8fc.svg";